var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topup-form"},[_c('div',{staticClass:"topup-form-frame"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('view.history.header')))]),_c('history-filter'),_c('history-pagination'),_c('history-list'),_c('history-pagination')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }